export const OAUTH_1A_REST_AUTH = 'OAuth 1.0a (SHA-256)'
export const OAUTH_2_REST_AUTH = 'OAuth 2'
export type RestAuthTypes = 'OAuth 1.0a' | 'OAuth 2'
